module.exports = __webpack_public_path__ + "assets/img/arrow_left_no.0ef6148f.png";